import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

const MobileTransactionCard = ({ trans, plate_no, formatDate, formatMoney, handleViewNotes }) => {
    return (
        <div className="bg-white rounded-xl shadow-sm p-4 flex flex-col">
            <div className="flex justify-between items-start">
                <div>
                    <div className="text-sm text-gray-500">{formatDate(trans.date)}</div>
                    <div className="mt-1 font-medium text-gray-800">{trans.type || 'Txn'}</div>
                </div>

                <div className="text-right">
                    <div className="text-sm text-gray-500">Balance</div>
                    <div className={`mt-1 font-mono font-bold ${Number(trans.post_balance) >= 0 ? 'text-gray-900' : 'text-red-600'}`}>{formatMoney(trans.post_balance)}</div>
                </div>
            </div>

            <div className="mt-3 flex items-center justify-between">
                <div className="text-sm text-gray-600">In: <span className="font-mono text-green-600">{formatMoney(trans.credit)}</span></div>
                <div className="text-sm text-gray-600">Out: <span className="font-mono text-red-600">{formatMoney(trans.debit)}</span></div>
            </div>

            <div className="mt-3 text-sm text-gray-700 truncate">Ref: {trans.your_ref || '-'}</div>

            <div className="mt-3 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    {trans.doc_no ? (
                        <Link to={`/cars/${plate_no}/pay/${trans.type}/${trans.doc_no}`} className="text-sm text-[#FF5733] hover:text-[#e64a2b]">
                            Doc: {trans.doc_no}
                        </Link>
                    ) : null}
                </div>

                <div className="flex items-center gap-3">
                    {trans.notes && (
                        <button onClick={() => handleViewNotes(trans)} aria-label="view-notes" className="text-[#FF5733] hover:text-[#e64a2b] inline-flex items-center">
                            <FontAwesomeIcon icon={faEye} className="w-4 h-4 mr-1" />
                            <span className="text-sm">View</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MobileTransactionCard;
